import { Component } from '@theme/component';

// Preserve the selected unpublished theme across ordinary internal navigation.
document.addEventListener('click', event => {
  const anchor = event.target.closest?.('a[href]');
  if (!anchor || anchor.getAttribute('href').startsWith('#')) return;
  const url = new URL(anchor.href, location.href);
  const themeId = document.body.dataset.vadorTheme;
  if (themeId && url.origin === location.origin && url.protocol.startsWith('http')) {
    url.searchParams.set('preview_theme_id', themeId);
    anchor.href = url.href;
  }
}, {capture:true});

class VadorHeader extends Component {
  connectedCallback(){super.connectedCallback();this.start();}
  updatedCallback(){super.updatedCallback();this.start();}
  start(){
    this.controller?.abort();
    this.controller=new AbortController();
    const on=(target,event,fn)=>target?.addEventListener(event,fn,{signal:this.controller.signal});
    const menu=this.querySelector('.menu-toggle'), nav=this.querySelector('#main-nav');
    const close=()=>{nav?.classList.remove('open');menu?.setAttribute('aria-expanded','false');};
    on(menu,'click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open);});
    nav?.querySelectorAll('a').forEach(a=>on(a,'click',close));
    on(document,'keydown',e=>{if(e.key==='Escape'&&nav?.classList.contains('open')&&!this.querySelector('[data-auto-nav]')?.open){close();menu.focus();}});
    const automotiveMenus=[...this.querySelectorAll('[data-auto-nav]')];
    automotiveMenus.forEach(automotive=>{
    on(document,'click',e=>{if(automotive?.open&&!automotive.contains(e.target))automotive.open=false;});
    on(document,'keydown',e=>{if(e.key==='Escape'&&automotive?.open){automotive.open=false;automotive.querySelector('summary')?.focus();}});
    on(automotive,'click',e=>{if(e.target.closest('a'))automotive.open=false;});
    });
    const bag=document.getElementById('bag-dialog');
    on(this.querySelector('#bag'),'click',()=>{bag?.showModal();document.getElementById('bag-title')?.focus();});
    on(bag?.querySelector('.close'),'click',()=>bag.close());
    on(document.getElementById('browse'),'click',()=>bag?.close());
  }
  disconnectedCallback(){this.controller?.abort();super.disconnectedCallback();}
}
if(!customElements.get('vador-header-component'))customElements.define('vador-header-component',VadorHeader);

